module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_1.7234ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_1.png
// module id = Ovlf
// module chunks = 6